import { mapState } from 'vuex';
export default {
  props: {},
  name: 'Loader',
  data: () => ({}),
  mounted() {},
  computed: {
    ...mapState('loader', ['loading'])
  }
};